import React, { useState } from 'react';
import numeral from 'numeral';
import SecondaryMarketItemSC, {
  AlertSC,
  TotalValueText,
  DetailText,
} from './secondary-market-item.styled';
import { SmallText, BodyText, BiggerText } from '../../typography';
import dlt from '../../../utils/default-lang';
import { FormattedMessage } from 'react-intl';
import Button from '../../ui/button';
import Moment from 'react-moment';
import { ReactComponent as TooltipIcon } from '../../../assets/img/svg/tip.svg';
import { ReactComponent as RightArrowIcon } from '../../../assets/img/svg/right-arrow-b.svg';
import { Link } from 'react-router-dom';

const SecondaryMarketItem = ({
  id,
  investmentId,
  isTablet,
  onBuyClick,
  onBidClick,
  hasPagination,
  name,
  loanSignedAt,
  installmentCount,
  paidInstallmentCount,
  isInArrears,
  value,
  futureValue,
  price,
  interestRate,
  alreadyBidding,
  offered,
}) => {
  const [isTooltipShown, setIsTooltipShown] = useState(false);

  return (
    <SecondaryMarketItemSC hasPagination={hasPagination}>
      {isTablet ? (
        <td>
          <Link to={`/investments/${investmentId}/${id}`}>
            <div>
              <DetailText className={isInArrears ? 'bolder red' : 'bolder'}>{name}</DetailText>
              {isInArrears ? (
                <AlertSC
                  onMouseEnter={() => setIsTooltipShown(true)}
                  onMouseLeave={() => setIsTooltipShown(false)}
                >
                  {isTooltipShown ? (
                    <div className="tooltip">
                      <TooltipIcon />
                      <FormattedMessage
                        id="investor_secondary_market_table_item_arrear_tooltip"
                        defaultMessage={dlt['investor_secondary_market_table_item_arrear_tooltip']}
                      />
                    </div>
                  ) : null}
                </AlertSC>
              ) : null}
            </div>
            <BiggerText className="bold green">{numeral(price).format('0,00.00')} €</BiggerText>
          </Link>
        </td>
      ) : (
        <>
          <td>
            <Link to={`/investments/${investmentId}/${id}`}>
              <BodyText className={isInArrears ? 'bolder red' : 'bolder'}>{name} </BodyText>
              {isInArrears ? (
                <AlertSC
                  onMouseEnter={() => setIsTooltipShown(true)}
                  onMouseLeave={() => setIsTooltipShown(false)}
                >
                  {isTooltipShown ? (
                    <div className="tooltip">
                      <TooltipIcon />
                      <FormattedMessage
                        id="investor_secondary_market_table_item_arrear_tooltip"
                        defaultMessage={dlt['investor_secondary_market_table_item_arrear_tooltip']}
                      />
                    </div>
                  ) : null}
                </AlertSC>
              ) : null}
            </Link>
          </td>
          <td>
            <Link to={`/investments/${investmentId}/${id}`}>
              <BodyText className={isInArrears ? 'red' : ''}>
                <Moment parse="YYYY-MM-DD" format="DD. MMMM YYYY">
                  {loanSignedAt}
                </Moment>
              </BodyText>
            </Link>
          </td>

          <td>
            <Link to={`/investments/${investmentId}/${id}`}>
              <BodyText className={isInArrears ? 'red' : ''}>
                {paidInstallmentCount} / {installmentCount}
              </BodyText>
            </Link>
          </td>
        </>
      )}

      {isTablet ? null : (
        <>
          <td>
            <Link to={`/investments/${investmentId}/${id}`}>
              <BodyText className={isInArrears ? 'red' : ''}>
                <TotalValueText className={isInArrears ? 'red' : ''}>
                  {numeral(value).format('0,00.00')} € /{' '}
                </TotalValueText>
                {numeral(offered).format('0,00.00')} €
              </BodyText>
            </Link>
          </td>
          <td>
            <Link to={`/investments/${investmentId}/${id}`}>
              <BodyText className={isInArrears ? 'red' : ''}>
                {numeral(futureValue).format('0,00.00')} €
              </BodyText>
            </Link>
          </td>
        </>
      )}

      {isTablet ? (
        <>
          <td>
            <Link to={`/investments/${investmentId}/${id}`}>
              <SmallText className={isInArrears ? 'red' : ''}>
                <Moment parse="YYYY-MM-DD" format="DD. MMMM YYYY">
                  {loanSignedAt}
                </Moment>
              </SmallText>
            </Link>
          </td>

          <td>
            <Link to={`/investments/${investmentId}/${id}`}>
              <SmallText className={isInArrears ? 'red transparented' : 'black-transparent'}>
                <FormattedMessage
                  id="investor_secondary_market_table_item_payments"
                  defaultMessage={dlt['investor_secondary_market_table_item_payments']}
                />{' '}
                {paidInstallmentCount} / {installmentCount}
              </SmallText>
            </Link>
          </td>
          <td>
            <Link to={`/investments/${investmentId}/${id}`}>
              <SmallText className={isInArrears ? 'red transparented' : 'black-transparent'}>
                <FormattedMessage
                  id="investor_secondary_market_table_value"
                  defaultMessage={dlt['investor_secondary_market_table_value']}
                />
                {': '}
                <span>{numeral(value).format('0,00.00')} € / </span>
                {numeral(offered).format('0,00.00')} €
              </SmallText>
            </Link>
          </td>
          <td>
            <Link to={`/investments/${investmentId}/${id}`}>
              <SmallText className={isInArrears ? 'red transparented' : 'black-transparent'}>
                <FormattedMessage
                  id="investor_secondary_market_table_item_future_value"
                  defaultMessage={dlt['investor_secondary_market_table_item_future_value']}
                />{' '}
                {numeral(futureValue).format('0,00.00')} €
              </SmallText>
            </Link>
          </td>
          <td>
            <Link to={`/investments/${investmentId}/${id}`}>
              <SmallText className={isInArrears ? 'red transparented' : 'black-transparent'}>
                <FormattedMessage
                  id="investor_secondary_market_table_item_rate"
                  defaultMessage={dlt['investor_secondary_market_table_item_rate']}
                />{' '}
                {numeral(interestRate).format('0.[00]')} %
              </SmallText>
            </Link>
          </td>

          <td>
            <Button
              type="PRIMARY"
              className="buy-button"
              size="MEDIUM"
              onClick={() => onBuyClick()}
            >
              <FormattedMessage id="global_buy" defaultMessage={dlt['global_buy']} />
            </Button>
            {alreadyBidding ? null : (
              <Button
                type="OUTLINED"
                className="bid-button"
                size="MEDIUM"
                onClick={() => onBidClick()}
              >
                <FormattedMessage id="global_bid" defaultMessage={dlt['global_bid']} />
              </Button>
            )}
          </td>
        </>
      ) : (
        <>
          <td>
            <Link to={`/investments/${investmentId}/${id}`}>
              <BodyText className={isInArrears ? 'red' : ''}>
                {numeral(interestRate).format('0.[00]')} %
              </BodyText>
            </Link>
          </td>
          <td>
            <Link to={`/investments/${investmentId}/${id}`}>
              <BodyText className="bolder green">{numeral(price).format('0,00.00')} €</BodyText>
            </Link>
          </td>
          <td>
            <Button
              type="PRIMARY"
              className="buy-button"
              size="MEDIUM"
              onClick={() => onBuyClick()}
            >
              <FormattedMessage id="global_buy" defaultMessage={dlt['global_buy']} />
            </Button>
            {alreadyBidding ? null : (
              <Button
                type="OUTLINED"
                className="bid-button"
                size="MEDIUM"
                onClick={() => onBidClick()}
              >
                <FormattedMessage id="global_bid" defaultMessage={dlt['global_bid']} />
              </Button>
            )}
          </td>
          <td>
            <Link to={`/investments/${investmentId}/${id}`}>
              <RightArrowIcon />
            </Link>
          </td>
        </>
      )}
    </SecondaryMarketItemSC>
  );
};

export default SecondaryMarketItem;
